import { render, staticRenderFns } from "./Factor.vue?vue&type=template&id=47254454&scoped=true"
import script from "./Factor.vue?vue&type=script&lang=js"
export * from "./Factor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47254454",
  null
  
)

export default component.exports